// @ts-nocheck
// Exact live (2026-10-15) version restored from the production sourcemap.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './translations/en.json';
import faqtoringEN from './translations/faqtoring.en.json';
import faqtoringNL from './translations/faqtoring.nl.json';
import LngDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-http-backend';
import moment from 'moment';
import dayjs from 'dayjs';
const resources = {
    en: {
        translation: translationEN,
        faqtoring: faqtoringEN
    },
    nl: { faqtoring: faqtoringNL }
};
i18n.use(XHR)
    .use(LngDetector)
    .use(initReactI18next)
    .init({
    resources,
    // The portal UI is English (decision H, 2026-10-22).
    lng: 'en',
    fallbackLng: 'en',
    keySeparator: '.',
    interpolation: {
        escapeValue: false
    }
});
// Date libraries format with their global locale; keep them English too (App.tsx also syncs moment to i18n.language).
// The Faqtoring namespace keeps its own nl resources; only the global date locale is fixed here.
moment.locale('en');
dayjs.locale('en');
export default i18n;
